import { ObservableFromFetch } from "../ObservableFromFetch"
import ParameterTypeData from "./Model/ParameterTypeData"


export  function ParameterTypeUpdate(data: ParameterTypeData) {
  const requestBody = JSON.stringify({
            ParameterType: data.ParameterType,
            ParameterTypeDescription: data.ParameterTypeDescription,
            CreatedBy: data.CreatedBy,
            ModifiedBy: data.ModifiedBy
  })

  return ObservableFromFetch<string>("FFOrderGlobalParameters/SetParameterType", requestBody)
}

export  function GetParameterType(parameterType: string) {
  const requestBody: string = new URLSearchParams({
      parameterType: parameterType.toString()
    }).toString()
  return ObservableFromFetch<ParameterTypeData>("FFOrderGlobalParameters/GetParameterByParameterType?" + requestBody)
}

export  function GetParameterTypes() {
  return ObservableFromFetch<ParameterTypeData[]>("FFOrderGlobalParameters/GetParameterType")
}
